<template>
  <div class="recommend">
    <h1>views/recommend.js 推荐列表</h1>
  </div>
</template>

<script>
export default {
  name: "recommend-module",
  components: {},
  methods: {},
  created() {}
};
</script>
